module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    on: {
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseleave,
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.touchstart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.touchmove($event)
      },
      "touchend": function($event) {
        $event.preventDefault();
        _vm.touchend($event)
      },
      "mousewheel": function($event) {
        $event.preventDefault();
        _vm.mousewheel($event)
      },
      "DOMMouseScroll": function($event) {
        $event.preventDefault();
        _vm.mousewheel($event)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.isXScrollbarRequired) ? _c('rect', {
    staticClass: "x-scrollbar",
    style: (_vm.xScrollbarStyle),
    attrs: {
      "x": _vm.viewportX,
      "y": _vm.viewportY + _vm.viewportHeight - 6,
      "width": _vm.xScrollbarWidth,
      "height": "5",
      "fill": "gray",
      "rx": "3",
      "ry": "3"
    },
    on: {
      "mousedown": _vm.mousedown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isYScrollbarRequired) ? _c('rect', {
    staticClass: "y-scrollbar",
    style: (_vm.yScrollbarStyle),
    attrs: {
      "x": _vm.viewportX + _vm.viewportWidth - 6,
      "y": _vm.viewportY,
      "width": "5",
      "height": _vm.yScrollbarHeight,
      "fill": "gray",
      "fill-opacity": ".3",
      "rx": "3",
      "ry": "3"
    },
    on: {
      "mousedown": _vm.mousedown
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b98c2d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Scrollbar.vue
// module id = 67
// module chunks = 0